import native from '@zz-common/native-adapter/es/all'
import { getDomainName } from '@/lib/utils'
import { url } from '@zz-yp/hunter-js-utils'
import { getCookie, decoratorUrl } from '@/lib/helper'
import { isExam } from './miniExamine'
import { checkHunterLoginStatus } from './miniAuth'

const $t = getCookie('t')
const domain = getDomainName($t)

export function Login(target, funcName, descriptor) {
  const oriFunc = descriptor.value
  descriptor.value = function () {
    if (!native.getUid()) {
      native.login({
        isHunter: true,
        callback: (res) => {
          if (res.code == 0) {
            return oriFunc.call(this, ...arguments)
          }
        },
        targetUrl: location.href
      })
    } else {
      return oriFunc.call(this, ...arguments)
    }
  }
}

// 重写adapter，并添加修饰模块
export function adapter() {
  /* eslint-disable */
  const decorator = {}
  const _proto_ = {}
  Object.getOwnPropertyNames(native).forEach((e) => (decorator[e] = native[e]))
  Object.getOwnPropertyNames(native.__proto__).forEach((e) => (_proto_[e] = native.__proto__[e]))
  modify(decorator)
  return Object.assign({}, native, _proto_, decorator)
  /* eslint-disable */
}

// 所有装饰器的修改在这里添加
function modify(decorator) {
  initSkipToUrl(decorator)
}

// 修改SkipToUrl，添加 needToMiniapp 在app时点击进入小程序
async function initSkipToUrl(decorator) {
  const base = `${domain}://jump/core/miniProgram/jump?userName=gh_3099e8332566&path=`
  const oriSkipToUrl = native.skipToUrl
  decorator.skipToUrl = async function (...arg) {
    // 检查登录状态
    const interceptRes = await checkHunterLoginStatus(...arg)
    if (!interceptRes) return false // 取消登录

    const status = await isExam()

    if (arg[0] && status) {
      const needNotAuth = 1
      const miniVersion = url.getParam('miniVersion')
      arg[0].targetUrl = url.setParams({ needNotAuth, miniVersion }, arg[0].targetUrl)
    }

    if (arg[0] && arg[0].needToMiniapp && native.in('zz')) {
      arg[0].targetUrl =
        base +
        encodeURIComponent(`pages/webview/bridge?url=${encodeURIComponent(arg[0].targetUrl)}`)
    }

    if (arg[0] && arg[0].targetUrl) {
      const url = arg[0].targetUrl
      arg[0].targetUrl = decoratorUrl(url)
    }

    oriSkipToUrl.call(this, ...arg)
  }
}
